import * as React from "react";
import styled from "styled-components";

import { CompanyMembershipSection, CompanyMembership } from "../entities";
import { media } from "../../common/utils/style";
import MembershipSectionHeader from "./MembershipSectionHeader";
import MembershipCardList from "./MembershipCardList";
import { OptionalProps } from "./MembershipCard";

export type RenderMembershipFunc = (
  args: {
    membership?: CompanyMembership;
    section?: CompanyMembershipSection;
    key: string;
  } & OptionalProps
) => React.ReactNode;

interface Props {
  section?: CompanyMembershipSection;
  memberships: CompanyMembership[];
  renderMembership: RenderMembershipFunc;
  editable: boolean;
}

const MembershipSection: React.SFC<Props> = props => {
  const { section, memberships, renderMembership, editable } = props;
  return (
    <SectionWrapper>
      {section && <MembershipSectionHeader section={section} memberships={memberships} editable={editable} />}
      <MembershipCardList memberships={memberships} renderMembership={renderMembership} limit={6} />
    </SectionWrapper>
  );
};

export const SectionWrapper = styled.div`
  border-top: 1px solid #eeeeee;
  padding-top: 30px;
  padding-bottom: 40px;
  @media ${media.large} {
    margin-top: 40px;
  }
`;

export default MembershipSection;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipSection.tsx